import {axiosGetHandler, axiosPostHandler} from './config'
const BASE_XIAOHEIHE_API = process.env.BASE_XIAOHEIHE_API

// 腾讯cdn上传文件信息
function getCdnUploadInfo (args, formdata) {
	var url = BASE_XIAOHEIHE_API + '/bbs/app/api/qcloud/cos/upload/info/v2'
	return axiosPostHandler(url, args, formdata)
}
// 腾讯cdn上传文件token
export function getCdnUploadToken (args, fromdata) {
	var url = BASE_XIAOHEIHE_API + '/bbs/app/api/qcloud/cos/upload/token/v2'
	return axiosPostHandler(url, args, fromdata)
}
// 腾讯cdn上传文件回调
function getCdnUploadCallback (args, formdata) {
	var url = BASE_XIAOHEIHE_API + '/bbs/app/api/qcloud/cos/upload/callback/v2'
	return axiosPostHandler(url, args, formdata)
}

function getCos (formdata = {}) {
  return new Promise((resolve, reject) => {
    import('cos-js-sdk-v5').then((COSModule) => {
      let COS = COSModule.default
      const cos = new COS({
        getAuthorization: (options, callback) => {
          getCdnUploadToken({}, formdata).then((res) => {
            const r = res.data.result
            callback({
              TmpSecretId: r.credentials.tmpSecretId,
              TmpSecretKey: r.credentials.tmpSecretKey,
              XCosSecurityToken: r.credentials.sessionToken,
              StartTime: r.startTime,
              ExpiredTime: r.expiredTime,
            })
          }).catch(err => {
            // 获取token失败
          })
        }
      })
      resolve(cos)
    }).catch(() => {
      reject()
    })
  })
}

export function getTencentCDNTokenInfo (file_infos, scope, type = '', source = '', ext = '') {
  let pObj = getCdnUploadInfo({}, {
    file_infos,
    scope,
    type,
    source,
    need_cache: 0,
    ext,
  })
  return pObj
}


/**
 * @typedef {Object} FileObj
 * @property {File} file 文件对象
 * @property {number} width 文件宽度
 * @property {number} height 文件高度
 * @property {Array} file_infos 文件信息
 */

/**
 * @typedef {Object} uploadToTencentCDNConfig
 * @property {string} bucket 存储桶
 * @property {Array} keys 文件key
 * @property {Array} file_infos 文件信息
 */

/**
 * 上传文件到腾讯CDN
 * @param {FileObj} fileObj 文件对象
 * @param {uploadToTencentCDNConfig} config 配置
 * @param {number} watermark 是否开启水印
 * @param {Function} cb 上传成功回调
 * @param {Function} errorCb 上传失败回调
 * @param {Function} progressCb 上传进度回调
 */
export function uploadToTencentCDN (fileObj, config, watermark, cb, errorCb, progressCb) {
  var headers = {}
  if (watermark == 1) {
    var dx = Math.round(fileObj.width / 335 * 9)
    var dy = Math.round(fileObj.height / 335 * 7)
    var spcent = 125
    headers = {
      'Pic-Operations': JSON.stringify({
        is_pic_info: 1,
        rules: [{
          fileid: config.keys[0],
          rule: `watermark/1/image/aHR0cDovL2ltZ2hleWJveC0xMjUxMDA3MjA5LmNvcy5hcC1zaGFuZ2hhaS5teXFjbG91ZC5jb20vaGV5Ym94X3dhdGVybWFyay5wbmc=/gravity/southeast/dx/${dx}/dy/${dy}/scatype/1/spcent/${spcent}`
        }],
      })
    }
  }
  getCos({
    bucket: config.bucket,
    keys: JSON.stringify(config.keys),
    mimetypes: JSON.stringify(fileObj.file_infos?.map(item => item.mimetype)),
    is_multipart_upload: config.is_multipart_upload ?? 0
  }).then((cos) => {
    cos.putObject({
      Bucket: config.bucket, /* 必须 */
      Region: 'ap-shanghai', /* 存储桶所在地域，必须字段 */
      Key: config.keys[0], /* 必须 */
      Body: fileObj.file, /* 必须 */
      Headers: headers,
      onTaskReady: (taskId) => {},
      onHashProgress: (progressData) => {},
      onProgress: (progressData) => { /* 非必须 */
        if (progressCb) {
          progressCb(progressData)
        }
      }
    }, (err, data) => {
      if (!err && data.statusCode === 200) {
        cdnCallback(config, cb, data, err)
      } else {
        if (errorCb) {
          errorCb(err, data)
        }
      }
    })
  })
}

function cdnCallback(config, cb, data, err) {
  getCdnUploadCallback({}, {
    keys: JSON.stringify([config.keys[0]])
  }).then((res) => {
    if (res.data.status == 'ok') {
      cb(err, data, res.data.result)
    }
  })
}

/**
 * 多文件上传到腾讯CDN
 * @param {FileObj[]} fileObjs 文件对象
 * @param {uploadToTencentCDNConfig} config 配置
 * @param {number} watermark 是否开启水印
 * @param {Function} cb 上传成功回调
 * @param {Function} errorCb 上传失败回调
 * @param {Function} progressCb 上传进度回调
 */
export async function multiUploadToTencentCDN (fileObjs, uploadToTencentCDNConfig, watermark, cb, errorCb, progressCb) {
  
  const cos = await getCos({
    bucket: config.bucket,
    keys: JSON.stringify(config.keys),
    mimetypes: JSON.stringify(fileObj.file_infos?.map(item => item.mimetype)),
    is_multipart_upload: config.is_multipart_upload ?? 0
  })

  cos.putObject({
    Bucket: config.bucket, /* 必须 */
    Region: 'ap-shanghai', /* 存储桶所在地域，必须字段 */
    Key: config.keys[0], /* 必须 */
    Body: fileObj.file, /* 必须 */
    Headers: headers,
    onTaskReady: (taskId) => {},
    onHashProgress: (progressData) => {},
    onProgress: (progressData) => { /* 非必须 */
      if (progressCb) {
        progressCb(progressData)
      }
    }
  }, (err, data) => {
    if (!err && data.statusCode === 200) {
      cdnCallback(config, cb, data, err)
    } else {
      if (errorCb) {
        errorCb(err, data)
      }
    }
  })
}